import { Helmet } from "react-helmet-async";

const SITE = "https://starframeai.com";
const OG_IMAGE = `${SITE}/og-image.jpg`;
const BRAND = "StarFrame AI";

const defaults = {
  title: `${BRAND} | #1 AI Portrait Studio — Transform Photos Into Stunning Art`,
  description: "Create jaw-dropping AI portraits in seconds. 12 iconic styles: LinkedIn headshots, magazine covers, red carpet glamour, anime, fantasy & more. Upload your selfie, get a masterpiece. 3 free credits.",
  image: OG_IMAGE,
};

export const SEO = ({ title, description, path = "/", image, noindex = false }) => {
  const fullTitle = title ? `${title} | ${BRAND}` : defaults.title;
  const desc = description || defaults.description;
  const url = `${SITE}${path}`;
  const img = image || defaults.image;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND} />

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};
